import { getNamespace } from './get-namespace';
let instance = null;
/**
 * SessionCorrelationSingleton Class used to init correlationId on shell Load
 *  - Used to set default request header in fetch.js
 *  - One time instantiation
 *  - Modifying/setCorrelationId will prevent over-riding initial value
 *  - We will get correlationId from sdk and populated in Redux state on shell load
 *  - Per current implementation, fetch is a utility and passing correlationId from all api invocation
 *    will not be ideal and workaround to set default headers on shell load is thru Singelton Object
 *  - We will refractor as part of May 2018 RELEASE.
 *  - _vToken: this is one time vToken that is received through Merchant Contstraint call
 */
class StaticIdSingleton {
  /**
   * Default constructor
   * - Multiple instantiation will provide same instance(First time instance)
   */
  constructor() {
    if (!instance) {
      instance = this; // eslint-disable-line consistent-this
    }
    this._apikey = null;
    this._correlationId = null;
    this._debug = null;
    this._sessionId = null;
    this._namespace = null;
    this._orgId = null;
    this._visaSrci = null;
    this.count = 1;
    return instance;
  }

  /**
   * Returns apikey
   * @returns {string} _apikey
   */
  get apikey() {
    return this._apikey;
  }

  /**
   * Set apikey and prevents recurring changes to inital value
   * @param {string} value
   */
  set apikey(value) {
    if (!this._apikey) {
      this._apikey = value;
    }
  }

  /**
   * Returns correlationId
   * @returns {string} _correlationId
   */
  get correlationId() {
    return this._correlationId;
  }

  /**
   * Set correlationId
   * @param {string} value
   */
  set correlationId(value) {
    this._correlationId = value;
  }

  /**
   * Returns debug
   * @returns {string} _debug
   */
  get debug() {
    return this._debug;
  }

  /**
   * Set debug and prevents recurring changes to inital value
   * @param {string} value
   */
  set debug(value) {
    if (!this._debug) {
      this._debug = value;
    }
  }

  /**
   * Returns sessionId
   * @returns {string} _sessionId
   */
  get sessionId() {
    return this._sessionId;
  }

  /**
   * Set sessionId
   * @param {string} value
   */
  set sessionId(value) {
    this._sessionId = value;
  }

  /**
   * Returns namespace
   * @returns {string} _namespace
   */
  get namespace() {
    return this._namespace || getNamespace();
  }

  /**
   * Set namespace and prevents recurring changes to inital value
   * @param {string} value
   */
  set namespace(value) {
    if (!this._namespace) {
      this._namespace = value;
    }
  }

  /**
   * Returns sessionId
   * @returns {string} orgId
   */
  get orgId() {
    return this._orgId;
  }

  /**
   * Set orgId and prevents recurring changes to inital value
   * @param {string} value
   */
  set orgId(value) {
    if (!this._orgId) {
      this._orgId = value;
    }
  }

  /**
   * Returns visaSrci
   * @returns {string} visaSrci
   */
  get visaSrci() {
    return this._visaSrci;
  }

  /**
   * Set visaSrci and prevents recurring changes to inital value
   * @param {string} value
   */
  set visaSrci(value) {
    if (!this._visaSrci) {
      this._visaSrci = value;
    }
  }
}

export default new StaticIdSingleton();
